import { Modal, Form } from "react-bootstrap";
import ErrorAlert from "../../../common/ui/ErrorAlert";

export default function CustomerDetailsModal(props) {
    const linkTCs = props.customerDetailsFormData.formData.TandCLink == '' || props.customerDetailsFormData.formData.TandCLink == null ? <a href="#" target="_self">Terms & Conditions</a> : <a href={props.customerDetailsFormData.formData.TandCLink} target="_blank">Terms & Conditions</a>;
    const formData = props.customerDetailsFormData.formData;
    const validation = props.customerDetailsFormData.validation;
    const isWebOrder = props.urlConfig.Type === '' || props.urlConfig.Type === null || props.urlConfig.Type === 'null' || props.urlConfig.Type === 'web'  ? true : false;

    return (
        <>
            <Modal show={props.showCustomerDetailsModal.IsShown} backdrop="static" keyboard={false}>
                <div className="modal-header">
                    <h1 className="modal-title fs-5">Add your details</h1>
                    <button type="button" className="btn-close" aria-label="Close" onClick={props.handleCloseCustomerDetailsModal} disabled={props.customerDetailsFormData.validation.ButtonsDisabled}></button>
                </div>
                <Modal.Body>
                <div className="row gy-3">
                    <div className="col-12">
                        <Form.Floating>
                            <Form.Control type="text" id="txtCustFirstName" name="firstname" className={validation.firstname.HasError ? "is-invalid" : ""} value={formData.firstname} onChange={props.handleChangeCustDetails} disabled={props.loyaltyIsLoggedIn} />
                            <label htmlFor="txtCustFirstName">First Name</label>
                            <Form.Control.Feedback type="invalid">{validation.firstname.ErrorMessage}</Form.Control.Feedback>
                        </Form.Floating>
                    </div>
                    {isWebOrder &&
                        <div className="col-12">
                            <Form.Floating>
                                <Form.Control type="text" id="txtCustLastName" name="lastname" className={validation.lastname.HasError ? "is-invalid" : ""} value={formData.lastname} onChange={props.handleChangeCustDetails} disabled={props.loyaltyIsLoggedIn} />
                                <label htmlFor="txtCustLastName">Last Name</label>
                                <Form.Control.Feedback type="invalid">{validation.lastname.ErrorMessage}</Form.Control.Feedback>
                            </Form.Floating>
                        </div>
                    }
                    <div className="col-12">
                        <Form.Floating>
                            <Form.Control type="text" id="txtCustEmail" name="email" className={validation.email.HasError ? "is-invalid" : ""} value={formData.email} onChange={props.handleChangeCustDetails} disabled={props.loyaltyIsLoggedIn} />
                            <label htmlFor="txtCustEmail">Email</label>
                            <Form.Control.Feedback type="invalid">{validation.email.ErrorMessage}</Form.Control.Feedback>
                        </Form.Floating>
                    </div>
                    {isWebOrder &&
                        <div className="col-12">
                            <Form.Floating>
                                <Form.Control type="tel" id="txtCustMobile" name="mobile" className={validation.mobile.HasError ? "is-invalid" : ""} value={formData.mobile} onChange={props.handleChangeCustDetails} disabled={props.loyaltyIsLoggedIn} />
                                <label htmlFor="txtCustMobile">Mobile</label>
                                <Form.Control.Feedback type="invalid">{validation.mobile.ErrorMessage}</Form.Control.Feedback>
                            </Form.Floating>
                        </div>
                    }
                    <div className="col-12">
                        <Form.Floating>
                            <Form.Control type="text" id="txtCustLoyaltyNum" name="cardnumber" value={formData.cardnumber} onChange={props.handleChangeCustDetails} disabled={props.loyaltyIsLoggedIn} />
                            <label htmlFor="txtCustLoyaltyNum">Loyalty Card Number (optional)</label>
                        </Form.Floating>
                    </div>
                    <div className="d-flex justify-content-center">
                        <div className="form-check form-switch">
                            <input className={`form-check-input ${validation.tandcs.HasError ? "is-invalid" : ""}`} type="checkbox" role="switch" id="switchCustTCs" name="tandcs" checked={formData.tandcs} onChange={props.handleChangeCustDetails} />
                            <label className="form-check-label" htmlFor="switchCustTCs">I accept the {linkTCs}</label>
                            <div className="invalid-feedback">{validation.tandcs.ErrorMessage}</div>
                        </div>
                    </div>
                </div>
                </Modal.Body>
                <Modal.Footer>
                    {props.customerDetailsFormData.validation.HasErrorAllFields && <div className="col-12 mx-auto mb-3"><ErrorAlert message={props.customerDetailsFormData.validation.AlertMessage} /></div>}
                    <div className="col-12 d-flex justify-content-center mx-auto">
                        <button type="button" className="btn btn-dark rounded-pill px-5" onClick={props.handleSubmitCustDetails} disabled={props.customerDetailsFormData.validation.ButtonsDisabled}>
                            Continue
                            { props.customerDetailsFormData.validation.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> }                         
                        </button>
                    </div>
                </Modal.Footer>               
            </Modal>
        </>
    )
}